import { newValidator } from '../../../../../../../utils';

const emailValidator = newValidator({
  type: 'email',
});

export const validateField = {
  email: value => emailValidator(value),
};
